import React from "react";
import "./AboutNav.css";

function AboutNav() {
  return (
    <div className="about__container" id="about">
      <div className="content__surrounder">
        <div className="elegant__title">
          <strong>Karim Darrag</strong>
          <br></br>
          <span style={{ color: "indianred" }}>
            <strong>Data Analyst</strong>
          </span>{" "}
          <br></br>Striving to be the best me that I can be.{" "}
        </div>
        <div className="elegant__image">
          <img src="./20220128_161737[122].jpg" alt="" />
        </div>
      </div>
    </div>
  );
}

export default AboutNav;
